/* ===========================================================================
 *  Getallen en datums zoals Blue10 ze op de telefoon zet
 *
 *  "€ 12.661,79", "US$ 300,00", "01 12 2026" en in het detail "01 12 26".
 *  De administratie kent die vorm; hier staat hij één keer.
 * =========================================================================== */

const geldVormen = new Map<string, Intl.NumberFormat>()

export function geld(bedrag: number | null | undefined, valuta?: string | null): string {
  const munt = /^[A-Z]{3}$/.test(valuta ?? '') ? valuta! : 'EUR'
  let v = geldVormen.get(munt)
  if (!v) {
    try {
      v = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: munt })
    } catch {
      v = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
    }
    geldVormen.set(munt, v)
  }
  return v.format(Number(bedrag ?? 0))
}

/** Het bedrag inclusief btw. Dezelfde som als inclusief() in lib/stroom.ts van het dashboard. */
export function inclusief(b: { amountExcl: number; btwBedrag?: number; vatPct?: number }): number {
  if (b.btwBedrag != null) return Math.round((b.amountExcl + b.btwBedrag) * 100) / 100
  return Math.round(b.amountExcl * (1 + (b.vatPct ?? 0) / 100) * 100) / 100
}

export function btwVan(b: { amountExcl: number; btwBedrag?: number; vatPct?: number }): number {
  return Math.round((inclusief(b) - b.amountExcl) * 100) / 100
}

const twee = (n: number) => String(n).padStart(2, '0')

/** 01 12 2026 */
export function datum(ms: number | null | undefined): string {
  if (!ms) return '-'
  const d = new Date(ms)
  return `${twee(d.getDate())} ${twee(d.getMonth() + 1)} ${d.getFullYear()}`
}

/** 01 12 26 */
export function datumKort(ms: number | null | undefined): string {
  if (!ms) return '-'
  const d = new Date(ms)
  return `${twee(d.getDate())} ${twee(d.getMonth() + 1)} ${twee(d.getFullYear() % 100)}`
}

/** 19-10-2026 11:20 */
export function moment(ms: number | null | undefined): string {
  if (!ms) return '-'
  const d = new Date(ms)
  return `${twee(d.getDate())}-${twee(d.getMonth() + 1)}-${d.getFullYear()} ${twee(d.getHours())}:${twee(d.getMinutes())}`
}

/** Eén of meer, met beide vormen uitgeschreven: Nederlandse meervouden leid je niet af. */
export function aantal(n: number, een: string, meer: string): string {
  return `${n.toLocaleString('nl-NL')} ${n === 1 ? een : meer}`
}
